import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=14236746&scoped=true"
import script from "./Step.vue?vue&type=script&lang=js"
export * from "./Step.vue?vue&type=script&lang=js"
import style0 from "./Step.vue?vue&type=style&index=0&id=14236746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14236746",
  null
  
)

export default component.exports